module.exports = __webpack_public_path__ + "img/方块初级大师@2x.f18becc7.png";